import { render, staticRenderFns } from "./row.vue?vue&type=template&id=41dfd926&scoped=true&lang=pug&"
import script from "./row.vue?vue&type=script&lang=coffee&"
export * from "./row.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dfd926",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccessibilityBtn: require('/opt/build/repo/library/components/globals/accessibility-btn.vue').default})
